<template>
    <div class="error">
        <div v-if="validationErrors">
            <ul class="alert alert-danger p-20">
                <li v-for="(value, key, index) in validationErrors" :key="index">{{ value }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['errors'],
        data() {
            return {

            }
        },
        computed: {
            validationErrors(){
                let errors = Object.values(this.errors);
                errors = errors.flat();
                return errors;
            }
        }
    }
    
</script>

<style scoped>
.main-menu-item:hover > .main-menu-item a i {
    color: #ff5f5f;
}
.opened-menu {
    height: calc(100vh - 68px);
    overflow: auto;
}
::-webkit-scrollbar {
  width: 3px;
  border-radius: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 3px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
ul {
}
ul li {
    margin-top: 10px;
}
.p-20 {
    padding: 20px 30px;
}
</style>